/**
 * Shared animated green flowing tendrils SVG background.
 * Used on Landing, Projects, Agent Catalog, and other pages
 * for a consistent visual identity.
 */
export default function GreenTendrils() {
  return (
    <svg
      className="absolute inset-0 w-full h-full opacity-40 pointer-events-none"
      viewBox="0 0 1200 800"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <linearGradient id="gt-g1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#86BC25" stopOpacity="0.6" />
          <stop offset="50%" stopColor="#A7D200" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#C4D600" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="gt-g2" x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#6CC24A" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#86BC25" stopOpacity="0" />
        </linearGradient>
        <filter id="gt-glow">
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {/* Flowing curves */}
      <path
        d="M-50,400 C200,350 400,200 600,280 S900,150 1250,300"
        stroke="url(#gt-g1)"
        strokeWidth="2"
        fill="none"
        filter="url(#gt-glow)"
      >
        <animate
          attributeName="d"
          values="M-50,400 C200,350 400,200 600,280 S900,150 1250,300;M-50,380 C200,300 400,250 600,200 S900,220 1250,280;M-50,400 C200,350 400,200 600,280 S900,150 1250,300"
          dur="10s"
          repeatCount="indefinite"
        />
      </path>
      <path
        d="M-50,500 C300,450 500,300 700,380 S1000,250 1300,400"
        stroke="url(#gt-g2)"
        strokeWidth="1.5"
        fill="none"
        filter="url(#gt-glow)"
      >
        <animate
          attributeName="d"
          values="M-50,500 C300,450 500,300 700,380 S1000,250 1300,400;M-50,480 C300,400 500,350 700,300 S1000,320 1300,380;M-50,500 C300,450 500,300 700,380 S1000,250 1300,400"
          dur="12s"
          repeatCount="indefinite"
        />
      </path>
      <path
        d="M-50,300 C150,250 350,350 550,250 S850,350 1250,200"
        stroke="url(#gt-g1)"
        strokeWidth="1"
        fill="none"
        opacity="0.5"
        filter="url(#gt-glow)"
      >
        <animate
          attributeName="d"
          values="M-50,300 C150,250 350,350 550,250 S850,350 1250,200;M-50,320 C150,200 350,300 550,200 S850,300 1250,220;M-50,300 C150,250 350,350 550,250 S850,350 1250,200"
          dur="14s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
}
